var _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActionIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.8334 13.5867H23.98C20.82 13.5867 18.2467 11.0133 18.2467 7.85331V3.99996C18.2467 3.26663 17.6467 2.66663 16.9134 2.66663H11.26C7.15337 2.66663 3.83337 5.3333 3.83337 10.0933V21.9067C3.83337 26.6667 7.15337 29.3334 11.26 29.3334H21.74C25.8467 29.3334 29.1667 26.6667 29.1667 21.9067V14.92C29.1667 14.1867 28.5667 13.5867 27.8334 13.5867ZM16.8734 21.04L14.2067 23.7067C14.1134 23.8 13.9934 23.88 13.8734 23.92C13.7534 23.9734 13.6334 24 13.5 24C13.3667 24 13.2467 23.9734 13.1267 23.92C13.02 23.88 12.9134 23.8 12.8334 23.72C12.82 23.7067 12.8067 23.7067 12.8067 23.6934L10.14 21.0267C9.75337 20.64 9.75337 20 10.14 19.6134C10.5267 19.2267 11.1667 19.2267 11.5534 19.6134L12.5 20.5867V15C12.5 14.4533 12.9534 14 13.5 14C14.0467 14 14.5 14.4533 14.5 15V20.5867L15.46 19.6267C15.8467 19.24 16.4867 19.24 16.8734 19.6267C17.26 20.0134 17.26 20.6534 16.8734 21.04Z",
    fill: "#7D14FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8334 13.5867H23.98C20.82 13.5867 18.2467 11.0133 18.2467 7.85331V3.99996C18.2467 3.26663 17.6467 2.66663 16.9134 2.66663H11.26C7.15337 2.66663 3.83337 5.3333 3.83337 10.0933V21.9067C3.83337 26.6667 7.15337 29.3334 11.26 29.3334H21.74C25.8467 29.3334 29.1667 26.6667 29.1667 21.9067V14.92C29.1667 14.1867 28.5667 13.5867 27.8334 13.5867ZM16.8734 21.04L14.2067 23.7067C14.1134 23.8 13.9934 23.88 13.8734 23.92C13.7534 23.9734 13.6334 24 13.5 24C13.3667 24 13.2467 23.9734 13.1267 23.92C13.02 23.88 12.9134 23.8 12.8334 23.72C12.82 23.7067 12.8067 23.7067 12.8067 23.6934L10.14 21.0267C9.75337 20.64 9.75337 20 10.14 19.6134C10.5267 19.2267 11.1667 19.2267 11.5534 19.6134L12.5 20.5867V15C12.5 14.4533 12.9534 14 13.5 14C14.0467 14 14.5 14.4533 14.5 15V20.5867L15.46 19.6267C15.8467 19.24 16.4867 19.24 16.8734 19.6267C17.26 20.0134 17.26 20.6534 16.8734 21.04Z",
    fill: "url(#paint0_linear_2946_45164)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.74 11.7467C25.0067 11.7601 26.7667 11.7601 28.2734 11.7601C29.0334 11.7601 29.4334 10.8667 28.9 10.3334C26.98 8.40005 23.54 4.92004 21.5667 2.9467C21.02 2.40003 20.0734 2.77337 20.0734 3.53337V8.18672C20.0734 10.1334 21.7267 11.7467 23.74 11.7467Z",
    fill: "#7D14FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.74 11.7467C25.0067 11.7601 26.7667 11.7601 28.2734 11.7601C29.0334 11.7601 29.4334 10.8667 28.9 10.3334C26.98 8.40005 23.54 4.92004 21.5667 2.9467C21.02 2.40003 20.0734 2.77337 20.0734 3.53337V8.18672C20.0734 10.1334 21.7267 11.7467 23.74 11.7467Z",
    fill: "url(#paint1_linear_2946_45164)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2946_45164",
    x1: 3.83337,
    y1: 2.66663,
    x2: 30.4651,
    y2: 27.9667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#873BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#873BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265,
    stopColor: "#873BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#A173FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#7D14FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.825,
    stopColor: "#873BFF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F00FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2946_45164",
    x1: 20.0734,
    y1: 2.68689,
    x2: 29.1465,
    y2: 11.7576,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#873BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#873BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265,
    stopColor: "#873BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#A173FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#7D14FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.825,
    stopColor: "#873BFF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F00FF",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionIcon);
export default __webpack_public_path__ + "static/media/action-icon.21b0ba675ea01224b1e19d7085c0c372.svg";
export { ForwardRef as ReactComponent };